export default {
    label_task:{
        en:"Report Setup",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Report",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Report",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Report",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_show_inputs:{
        en:"Report Fields",
        bn:"প্রিফিক্স"
    },
    label_report_column_name:{
        en:"Report Column Name",
        bn:"প্রিফিক্স"
    },
    label_equation:{
        en:"Equation",
        bn:"প্রিফিক্স"
    },
    label_formula:{
        en:"Formula",
        bn:"প্রিফিক্স"
    },
    label_visible:{
        en:"visible",
        bn:"প্রিফিক্স"
    },
}